import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

function initContactMap() {
    const mapEl = document.getElementById('contact-map__leaflet');

    if (!mapEl) return;

    const lat = parseFloat(mapEl.dataset.lat);
    const lng = parseFloat(mapEl.dataset.lng);
    const zoom = parseInt(mapEl.dataset.zoom, 10);

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
        console.error('Nieprawidłowe współrzędne mapy');
        return;
    }

    const map = L.map(mapEl, {
        zoomControl: true,
        scrollWheelZoom: false,
    }).setView([lat, lng], zoom);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20,
    }).addTo(map);


    const markerSvg = `
        <svg width="91" height="114" viewBox="0 0 91 114" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="91" height="91" rx="45.5" fill="#854526"/>
            <g clip-path="url(#clip0_31_2861)">
            <path d="M51.9467 51.5521C51.1715 52.3423 50.2659 52.9577 49.2855 53.3813C48.5372 53.7043 47.7429 53.917 46.9217 54.0082C46.6167 54.0424 46.3097 54.0633 45.9989 54.0633C43.7541 54.0633 41.6417 53.1705 40.0511 51.554C38.4625 49.9355 37.5876 47.7833 37.5876 45.4943C37.5876 43.2054 38.4644 41.0532 40.0511 39.4328C41.6359 37.8182 43.7483 36.9273 45.9989 36.9273C48.2494 36.9273 50.3619 37.8163 51.9467 39.4328C53.5353 41.0513 54.4102 43.2035 54.4102 45.4943C54.4102 46.8753 54.0859 48.2031 53.4854 49.3961C53.0902 50.1806 52.576 50.9119 51.9467 51.554M65.0298 62.6037L55.2141 52.6044L55.2563 52.5493C55.6535 52.0118 55.9988 51.4419 56.2962 50.8549C57.1346 49.2023 57.574 47.3825 57.574 45.4905C57.574 42.3411 56.3691 39.3796 54.1819 37.1496C51.9985 34.9271 49.0917 33.7 45.995 33.7C42.8984 33.7 39.9936 34.9233 37.8121 37.1496C35.6248 39.3777 34.4199 42.3392 34.4199 45.4905C34.4199 48.6419 35.6248 51.6014 37.8121 53.8277C39.9993 56.0559 42.9041 57.283 45.995 57.283C46.421 57.283 46.845 57.2527 47.2652 57.2052C48.3895 57.0798 49.485 56.7949 50.5173 56.3447C51.3634 55.9761 52.1692 55.5013 52.9213 54.9257L52.975 54.8839L61.678 63.7492L61.6127 63.8062C59.6826 65.5196 57.5644 66.8796 55.3119 67.856L56.5456 70.8117C59.7363 69.4346 62.6085 67.4666 65.0836 64.9421C65.4558 64.5603 65.7781 64.2146 66.1753 63.7549L65.0836 62.6664L65.0241 62.6056H65.026L65.0298 62.6037Z" fill="#F5F5F5"/>
            <path d="M65.0895 26.0428C59.9974 20.8569 53.2169 18 45.9971 18C38.7773 18 31.9988 20.8569 26.9086 26.0428C21.8089 31.2381 19 38.1449 19 45.4905C19 52.8361 21.8089 59.7467 26.9086 64.942C32.0083 70.1374 38.7869 73 45.999 73C46.9603 73 47.9541 72.9392 48.9614 72.8271L48.6141 69.6207C47.6625 69.727 46.8049 69.7802 45.999 69.7802C39.633 69.7802 33.6449 67.2538 29.1438 62.6664C24.6427 58.0789 22.1619 51.9813 22.1619 45.4943C22.1619 39.0073 24.6408 32.9097 29.1438 28.3241C33.6373 23.7443 39.6234 21.2236 45.999 21.2236C52.3747 21.2236 58.357 23.7443 62.8543 28.3241C67.3554 32.9097 69.8362 39.0073 69.8362 45.4943C69.8362 49.3694 68.9555 53.085 67.2153 56.5384L70.0338 58.0048C71.9716 54.1525 73.0019 49.8424 73.0019 45.4943C73.0019 38.1468 70.193 31.2381 65.0933 26.0466H65.0914L65.0895 26.0428Z" fill="#F5F5F5"/>
            </g>
            <path d="M45.5 114L29.4785 86.25L61.5215 86.25L45.5 114Z" fill="#854526"/>
            <defs>
            <clipPath id="clip0_31_2861">
            <rect width="54" height="55" fill="white" transform="translate(19 18)"/>
            </clipPath>
            </defs>
        </svg>
    `;


    function getMarkerOptions() {
        const isDesktop = window.innerWidth >= 992;

        return {
            iconSize: isDesktop ? [91, 114] : [40, 50],
            iconAnchor: isDesktop ? [45.5, 114] : [20, 50],
        };
    }


    function createMarkerIcon() {
        const options = getMarkerOptions();

        return L.divIcon({
            className: 'contact-map__marker',
            html: markerSvg,
            iconSize: options.iconSize,
            iconAnchor: options.iconAnchor,
            popupAnchor: [0, -options.iconAnchor[1]],
        });
    }


    const marker = L.marker([lat, lng], {
        icon: createMarkerIcon(),
    }).addTo(map);


    let resizeTimeout;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
            marker.setIcon(createMarkerIcon());
            map.invalidateSize();
        }, 150);
    });


    setTimeout(() => {
        map.invalidateSize();
    }, 100);
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactMap);
} else {
    initContactMap();
}